import { MtAccount } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setAccountList = (accountList: types.AccountList) => ({
    type: inferLiteral(types.ACCOUNT_LIST),
    accountList,
})
export const setAccountIds = (accountIds: readonly number[]) => ({
    type: inferLiteral(types.ACCOUNT_IDS),
    accountIds,
})
export const setAccountView = (account: MtAccount) => ({
    type: inferLiteral(types.ACCOUNT_VIEW),
    account,
})
export const setAccountEdit = (account: MtAccount) => ({
    type: inferLiteral(types.ACCOUNT_EDIT),
    account,
})
export const setAccountSort = (sortColumn: keyof MtAccount, sortOrder: OrderType) => ({
    type: inferLiteral(types.ACCOUNT_SORT),
    sortColumn,
    sortOrder,
})
export const setAccountFilters = (filters: types.AccountFilters) => ({
    type: inferLiteral(types.ACCOUNT_FILTERS),
    filters,
})
export const setAccountReloadList = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_RELOAD_LIST),
    value,
})
export const setAccountReloadView = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_RELOAD_VIEW),
    value,
})
export const setAccountReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_RELOAD_EDIT),
    value,
})
